/* INNOR — rail UGC de la fiche produit : carrousel en BOUCLE VRAIE.

   Pourquoi un moteur à part plutôt que `innor-carrousel.js` : celui-là est
   écrit pour une pellicule qui montre UN cadre à la fois. Il désigne le cadre
   courant par IntersectionObserver, ce qui n'a plus de sens quand quatre
   cadres sont visibles en même temps — mesuré, le compteur sautait
   08 01 05 08 au lieu d'avancer d'un.

   Et surtout, sa boucle ne joue que sur les chevrons : au doigt, un conteneur
   à défilement natif s'arrête au dernier cadre. Le client veut que ça tourne
   en rond dans les deux gestes.

   Méthode : on TRIPLE la liste. Le lecteur regarde toujours la copie du
   milieu ; dès qu'il s'approche d'un bord, on le repose silencieusement d'une
   largeur de série. Le saut est invisible parce qu'il tombe sur une image
   identique, et le défilement natif (donc l'inertie du doigt, la molette et
   l'accrochage) est conservé. */
(function () {
  'use strict';

  function deuxChiffres(n) { return n < 10 ? '0' + n : String(n); }

  function bind(root) {
    var rail = root.querySelector('[data-ugc-rail]');
    if (!rail) return;
    var originaux = Array.prototype.slice.call(rail.children);
    var n = originaux.length;
    if (!n) return;

    var compteur = root.querySelector('[data-ugc-current]');
    var prev = root.querySelector('[data-ugc-prev]');
    var next = root.querySelector('[data-ugc-next]');
    var reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Une seule série ne peut pas boucler : il faut de la matière des deux
       côtés. En dessous de trois cadres, tripler ne suffit pas à remplir un
       écran large, on double encore. */
    var copies = n < 4 ? 5 : 3;
    var milieu = Math.floor(copies / 2);
    for (var c = 0; c < copies; c++) {
      if (c === milieu) continue;
      originaux.forEach(function (item) {
        var clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.dataset.ugcClone = '1';
        rail.appendChild(clone);
      });
    }
    /* Remise dans l'ordre : les clones ont été empilés à la fin, on réinsère
       la série d'origine à sa place au milieu. */
    var tous = Array.prototype.slice.call(rail.children);
    var avant = tous.slice(n);
    rail.textContent = '';
    avant.slice(0, milieu * n).forEach(function (e) { rail.appendChild(e); });
    originaux.forEach(function (e) { rail.appendChild(e); });
    avant.slice(milieu * n).forEach(function (e) { rail.appendChild(e); });

    function pas() {
      var a = rail.children[0].getBoundingClientRect();
      var b = rail.children[1] ? rail.children[1].getBoundingClientRect() : a;
      return (b.left - a.left) || a.width;
    }
    function serie() { return pas() * n; }

    var cale = false;
    /* Recentrage par rapport à l'ANCRE du milieu, et non par rapport aux bords.
       Les seuils en bords sont un piège : le défilement maximum vaut
       scrollWidth - clientWidth, donc dès que plusieurs cadres sont visibles il
       tombe SOUS le seuil haut, qui devient inatteignable. Mesuré avec 6 clips
       en 1440 px : seuil à 5124 px pour un maximum de 4779, le rail tapait la
       butée et le compteur restait figé sur 03.
       Ici on ramène toujours la position à moins d'une demi-série de l'ancre,
       ce qui ne dépend plus de la largeur visible. */
    function recentrer() {
      var s = serie();
      if (!s) return;
      var ancre = s * milieu, ecart = rail.scrollLeft - ancre;
      if (Math.abs(ecart) < s * 0.5) return;
      cale = true;
      rail.scrollLeft -= Math.round(ecart / s) * s;
      cale = false;
    }

    var segments = root.querySelectorAll('[data-ugc-jauge] span');
    function marquer() {
      var s = serie();
      if (!s) return;
      var i = ((Math.round(rail.scrollLeft / pas()) % n) + n) % n;
      if (compteur) compteur.textContent = deuxChiffres(i + 1);
      /* La jauge ne s'affiche que sous 700 px, mais on la tient à jour à
         toutes les largeurs : c'est moins cher qu'un matchMedia à surveiller,
         et un changement d'orientation n'a rien à rattraper. */
      for (var k = 0; k < segments.length; k++) {
        if (k === i) segments[k].setAttribute('data-actif', '');
        else segments[k].removeAttribute('data-actif');
      }
    }

    var anim = null;
    function glisser(delta) {
      if (anim) cancelAnimationFrame(anim);
      var depart = rail.scrollLeft, cible = depart + delta;
      if (reduit) { rail.scrollLeft = cible; recentrer(); marquer(); return; }
      /* Comme dans innor-carrousel.js : l'accrochage obligatoire avale une
         animation écrite à la main, on le suspend le temps du glissement. */
      rail.style.scrollSnapType = 'none';
      var t0 = null, duree = 420;
      function fin() {
        anim = null; rail.scrollLeft = cible;
        rail.style.scrollSnapType = ''; recentrer(); marquer();
      }
      var filet = setTimeout(fin, duree + 150);
      function etape(t) {
        if (t0 === null) t0 = t;
        var p = Math.min(1, (t - t0) / duree);
        rail.scrollLeft = depart + delta * (1 - Math.pow(1 - p, 3));
        if (p < 1) anim = requestAnimationFrame(etape);
        else { clearTimeout(filet); fin(); }
      }
      anim = requestAnimationFrame(etape);
    }

    if (prev) prev.addEventListener('click', function () { glisser(-pas()); });
    if (next) next.addEventListener('click', function () { glisser(pas()); });

    rail.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); glisser(pas()); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); glisser(-pas()); }
    });

    var attente = null;
    rail.addEventListener('scroll', function () {
      if (cale || anim) return;
      marquer();
      /* On ne repose le rail qu'une fois le doigt arrêté : déplacer
         scrollLeft pendant une inertie tactile la coupe net. */
      clearTimeout(attente);
      attente = setTimeout(recentrer, 140);
    }, { passive: true });

    /* `index` est la position LOGIQUE dans la série, seule chose à conserver
       quand la mise en page change. Reposer aveuglément au milieu renvoyait au
       premier clip à chaque redimensionnement — et les vidéos qui finissent de
       charger en déclenchent un, donc le carrousel se bloquait en cours de
       route. Mesuré : le compteur restait figé sur 03. */
    var index = 0;
    /* LECTURE PILOTÉE PAR LA VISIBILITÉ.

       Sans ça, tripler la liste triple les vidéos : 6 clips devenaient 18
       éléments qui se téléchargeaient tous au chargement. Mesuré avant
       correction : 17,8 Mo transférés et un écran vide le temps que ça
       descende. On ne lance donc que ce qui est réellement à l'écran, et on
       met en pause dès que ça sort du cadre — la bande passante suit le
       regard. Le `poster` (celui de l'éditeur ou l'aperçu généré par Shopify)
       assure qu'un cadre montre quelque chose avant même de charger. */
    /* LE RAIL N'AGIT QUE QUAND IL APPROCHE DE L'ÉCRAN (01/10/2026).

       L'observateur ci-dessous a pour racine le rail, pas la fenêtre : un
       cadre y est « visible » même quand le rail entier est six écrans plus
       bas. Résultat mesuré : les vidéos se lançaient, et leurs affiches
       descendaient (jusqu'à 676 ko), dès l'ouverture de la fiche. On ajoute donc
       un second observateur, celui-là sur la fenêtre, avec 300 px d'avance :
       tant que le rail est loin, rien n'est téléchargé ni lu. */
    var affiches = Array.prototype.slice.call(rail.querySelectorAll('video[data-poster]'));
    function poserAffiches() {
      affiches.forEach(function (v) {
        if (v.dataset.poster) { v.poster = v.dataset.poster; v.removeAttribute('data-poster'); }
      });
      affiches = [];
    }
    function lire(v) { var j = v.play(); if (j && j.catch) j.catch(function () {}); }

    if ('IntersectionObserver' in window) {
      var railVu = false, enVue = new Set();
      var appliquer = function () {
        Array.prototype.forEach.call(rail.children, function (item) {
          var v = item.querySelector('video');
          if (!v) return;
          if (railVu && enVue.has(item)) lire(v);
          else if (!v.paused) v.pause();
        });
      };
      var oeil = new IntersectionObserver(function (entrees) {
        entrees.forEach(function (e) {
          if (e.isIntersecting) enVue.add(e.target); else enVue.delete(e.target);
        });
        appliquer();
        /* 0.6 et non 0.35 : sur un petit téléphone le cadre borné en hauteur
           ne fait plus que 240 px de large, l'amorce du suivant en montre 43 %
           et DEUX vidéos jouaient en même temps. Mesuré sur iPhone SE. */
      }, { root: rail, threshold: 0.6 });
      Array.prototype.forEach.call(rail.children, function (item) { oeil.observe(item); });

      new IntersectionObserver(function (entrees) {
        railVu = entrees[0].isIntersecting;
        if (railVu) poserAffiches();
        appliquer();
      }, { rootMargin: '300px 0px' }).observe(rail);
    } else {
      /* Sans observateur, on se rabat sur la série d'origine seule. */
      poserAffiches();
      originaux.forEach(function (item) {
        var v = item.querySelector('video');
        if (v) lire(v);
      });
    }

    /* `scroll-snap-align: start` accroche sur le bord du SCROLLPORT, padding
       compris. Poser scrollLeft sur la seule largeur de série collait donc le
       cadre courant au bord de l'écran pendant que le titre, le compteur et la
       méta restaient à la marge — mesuré : 16 px d'écart, et la ligne de vues
       tronquée. On retranche le padding, et le mobile pose en plus un
       scroll-padding pour que l'accrochage tombe au même endroit. */
    function marge() {
      return parseFloat(getComputedStyle(rail).paddingInlineStart) || 0;
    }
    function poser(garder) {
      var s = serie();
      if (!s) return;
      cale = true;
      rail.scrollLeft = s * milieu + (garder ? index * pas() : 0) - marge();
      cale = false;
      marquer();
    }
    function suivreIndex() {
      var p = pas();
      if (p) index = ((Math.round(rail.scrollLeft / p) % n) + n) % n;
    }
    rail.addEventListener('scroll', suivreIndex, { passive: true });

    poser(false);
    var recalcul = null;
    function replacer() {
      clearTimeout(recalcul);
      recalcul = setTimeout(function () { poser(true); }, 120);
    }
    window.addEventListener('resize', replacer);
    /* Uniquement sur changement de LARGEUR : la hauteur bouge toute seule
       quand une vidéo se charge, et ça ne doit rien déplacer. */
    if (window.ResizeObserver) {
      var derniere = rail.clientWidth;
      new ResizeObserver(function () {
        if (rail.clientWidth === derniere) return;
        derniere = rail.clientWidth;
        replacer();
      }).observe(rail);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-ugc]').forEach(bind);
  });
})();
